import {createSapiFetch} from './utils'

class StorefrontAPI {
    constructor(config = {}) {
        this.fetch = createSapiFetch(config)
    }

    /**
     * @param {Object} args
     * @return {Promise<object>}
     */
    async getGeoIpData(...args) {
        const sapiResponse = await this.fetch('geoip', 'GET', args, 'getGeoIpData')
        let result
        try {
            result = JSON.parse(sapiResponse).geoData
        } catch {} // eslint-disable-line no-empty
        return result
    }

    /**
     * @param {Object} args
     * @return {Promise<object>}
     */
    async storeErrorData(...args) {
        await this.fetch('csp', 'POST', args, 'csp', {
            'csp-report': {'document-uri': ''},
            content: args[0].body
        })
    }
}

export default StorefrontAPI
